import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from '../profile.module.scss';
import colors from '../../../../utils/colors';

const Support = () => {
    const { t } = useTranslation();
    return (
        <Box>
            <Typography
                sx={{ marginBottom: '1rem', borderBottom: '1px solid rgba(0, 0, 0, 0.2)' }}
                fontSize={'34px'}>
                {t('NeedAHand')}
            </Typography>
            <Box className={styles.upgradeSection}>
                <Typography sx={{ marginTop: '1rem' }}>
                    {t('SupportText1')}
                    <a
                        href="mailto:support@plinks.tv"
                        style={{ color: 'black', textDecoration: 'underline' }}>
                        support@plinks.tv
                    </a>
                    <span>{t('SupportText2')}</span>
                </Typography>

                <Button onClick={() => (window.location.href = 'mailto:support@plinks.tv')}>
                    {t('Contact')}
                </Button>
            </Box>
        </Box>
    );
};

export default Support;
